import React, { useEffect, useState } from 'react'
import { Container, Dropdown, Badge} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

export default function Topbar({rol}) {
	const { t } = useTranslation()
	const { clientauth, logoutClient } = useAuth()

  	return (
        <div className='sticky-top topbar py-2'>
            <Container className="d-none d-md-flex justify-content-end align-items-center">
                <div className='me-3'>{clientauth?.firstname} {clientauth?.lastname}</div>
                <Dropdown className=''>
                    <Dropdown.Toggle variant='drop' id="dropdown-basic" className='ms-auto'>
                        <i className="fas fa-bars"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            as={Link}
                            to={`/${t("url.employee.employee")}/${t("url.employee.profile")}`}>{t('menu.profile')}
                        </Dropdown.Item>
                        <Dropdown.Item
                            as={Link}
                            to="/"
                            onClick={logoutClient}>{t('menu.logout')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Container>
        </div>
	)
}